"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropdownSubTitle = void 0;
const theme_1 = require("@pulse-web-ui/theme");
require("react");
exports.DropdownSubTitle = theme_1.styled.div `
  ${theme_1.typography.regular14}
  line-height: 20px;
  color: ${({ theme }) => theme.colors.text.secondary};
  text-align: center;
  margin-bottom: 16px;
  white-space: break-spaces;
  word-break: break-word;
`;
